import './index.scss'

const width = document.documentElement.offsetWidth

const footer_top = document.querySelector('.footer_top')
const footer_map = document.querySelector('.footer_map')

if (width <= 430) {
    footer_top.prepend(footer_map)
}